// Gratis-actie: alles gratis voor iedereen t/m 31 december 2026.
// Daarna automatisch terug naar het betaalmodel (Pro €39/kwartaal, €3 per offerteaanvraag).
export const FREE_UNTIL = new Date("2026-12-31T23:59:59Z");
export const PRO_PRICE_LABEL = "€39/kwartaal";

export function isFreePeriod() {
  return Date.now() <= FREE_UNTIL.getTime();
}
